import React from "react";
import { FaInstagram, FaLinkedinIn } from "react-icons/fa";
import { FiFacebook, FiYoutube } from "react-icons/fi";
import logo from "../../assets/images/logo.svg";
import footerBg from "../../assets/images/backgrounds/footerBg.webp";
import { Link, useNavigate } from "react-router-dom";
import { ROUTES_NAME } from "../../constants/routes";
import { TbPhoneCall } from "react-icons/tb";
import { IoLocationOutline } from "react-icons/io5";
import footerInsta from "../../assets/images/footerInsta.webp";

const Footer = () => {
  const navigate = useNavigate();

  return (
    <footer
      className="text-[#202020] pt-16 bg-no-repeat bg-cover bg-center"
      style={{
        backgroundImage: `url(${footerBg})`,
      }}
    >
      <div className="max-w-7xl mx-auto md:px-12 px-6 grid grid-cols-2 md:grid-cols-4 gap-10">
        {/* Column 1 - Logo and Description */}
        <div className="col-span-2 md:col-span-1">
          <div
            className="flex items-center gap-2 mb-4 cursor-pointer"
            onClick={() => {
              navigate(ROUTES_NAME.HOME);
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: "smooth" });
              }, 100);
            }}
          >
            <img src={logo} alt="logo" className="h-10 w-auto" />
          </div>
          <p className="text-sm leading-relaxed font-outfitRegular">
            Bringing Real Exam Rehearsals, Seamless LMS & ERP Solutions, Instant
            Results, and Smart Tech to Coaching Centers Across India—Empowering
            Institutes and Students for Greater Success.
          </p>
        </div>

        {/* Column 2 - Services */}
        <div>
          <h3 className="font-semibold text-lg underline underline-offset-4 mb-4">
            Services
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                onClick={() => {
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={ROUTES_NAME.SERVICES}
              >
                Real Exam Experience
              </Link>
            </li>
            <li>
              <Link
              onClick={() => {
                setTimeout(() => {
                  window.scrollTo({ top: 0, behavior: "smooth" });
                }, 100);
              }}
                to={ROUTES_NAME.SERVICES}
              >
                Result Processing System
              </Link>
            </li>
            <li>
              <Link
                onClick={() => {
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={ROUTES_NAME.SERVICES}
              >
                LMS & ERP
              </Link>
            </li>
            <li>
              <Link
                onClick={() => {
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={ROUTES_NAME.SERVICES}
              >
                Custom Mobile Apps
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 3 - Company */}
        <div>
          <h3 className="font-semibold text-lg underline underline-offset-4 mb-4">
            Company
          </h3>
          <ul className="space-y-2 text-sm">
            <li>
              <Link
                onClick={() => {
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={ROUTES_NAME.ABOUT}
              >
                About
              </Link>
            </li>
            <li>
              <Link
                onClick={() => {
                  setTimeout(() => {
                    window.scrollTo({ top: 0, behavior: "smooth" });
                  }, 100);
                }}
                to={ROUTES_NAME.CONTACT_US}
              >
                Contact Us
              </Link>
            </li>
          </ul>
        </div>

        {/* Column 4 - Instagram */}
        <div className="hidden md:block">
          <h3 className="font-semibold text-lg underline underline-offset-4">
            Instagram
          </h3>
          {/* <div className="grid grid-cols-3 gap-2">
            {[...Array(9)].map((_, i) => (
              <div
                key={i}
                className="w-full aspect-square bg-white/80 rounded shadow"
              />
            ))}
          </div>*/}
          <img
            src={footerInsta}
            alt="footerInsta"
            className="w-96 -ml-5"
            loading="lazy"
            decoding="async"
          />
        </div>
      </div>
      <div className="pt-10 px-4 md:px-12 rounded-lg md:max-w-7xl md:-mt-24  m-auto">
        <h2 className="text-xl md:text-2xl font-semibold mb-2 text-black">
          Contact Us
        </h2>
        <div className="flex flex-col md:flex-row md:pt-4">
          {/* Address Card */}
          <div className="flex items-start gap-4  py-4 md:py-0 w-full md:w-[40%]">
            <div className="bg-white p-1 rounded-md text-primary-900 text-3xl shadow-md">
              <IoLocationOutline />
            </div>
            <div>
              <p className="font-medium ">Office Address</p>
              <Link
                to={"https://www.google.co.in/maps/place/9,+Shreeji+Heights,+Sahara+City+Homes,+Indore,+Madhya+Pradesh+452016/@22.6944711,75.9265266,17.3z/data=!4m14!1m7!3m6!1s0x3962e319ffebc92d:0x4b6b84d40b87eba8!2s11,+Sampat+Hills+Rd,+Pragati+Vihar,+Madhya+Pradesh+452016!3b1!8m2!3d22.6950516!4d75.9290841!3m5!1s0x3962e319c5f08559:0x44f29258d725b674!8m2!3d22.6957625!4d75.9267703!16s%2Fg%2F11j59bvw4_?entry=ttu&g_ep=EgoyMDI2MDkwNi4wIKXMDSoASAFQAw%3D%3D"}
                target="_block"
                className="cursor-pointer hover:underline"
              >
                <p className="text-sm font-outfitRegular">
                  11, Sampat Hills, Bicholi Mardana, Indore
                  <br />
                  -452016 (M.P.)
                </p>
              </Link>
            </div>
          </div>

          {/* Call Card */}
          <div className="flex items-start gap-4 w-full md:w-1/2">
            <div className="bg-white p-1 rounded-md text-primary-900 text-3xl shadow-md">
              <TbPhoneCall />
            </div>
            <div>
              <p className="font-medium">Call us :</p>
              <p className="text-sm  font-outfitRegular">
                <Link to="tel:+918962742339" className="hover:underline">
                  +91-89627-42339
                </Link>
              </p>
              <p className="text-sm  font-outfitRegular">
                <Link to="tel:0731-4199961" className="hover:underline">
                  0731-4199961
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
      {/* Bottom Footer */}
      <div className="bg-[#12255B] text-white text-sm mt-10 py-5 px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4">
          <p>© 2025 Eduprohub. All Rights Reserved.</p>
          <div className="flex gap-4 items-center">
            <Link to={ROUTES_NAME.PRIVACY_POLICY} className="hover:underline">
              Privacy Policy
            </Link>
            <span>|</span>
            <Link
              to={ROUTES_NAME.TERMS_AND_CONDITIONS}
              className="hover:underline"
            >
              Terms & Conditions
            </Link>
          </div>
          <div className="flex items-center gap-3 ">
            <span className="hidden sm:inline">Follow us:</span>
            <Link
              to={"https://www.facebook.com/people/EduproHub/61574560987507/"}
              target="_block"
              className="bg-white text-xl text-defaultText p-1 rounded-md hover:text-primary-900"
            >
              <FiFacebook className="" />
            </Link>
            <Link
              to={"https://www.instagram.com/eduprohub_parikshado/"}
              target="_block"
              className="bg-white text-xl text-defaultText p-1 rounded-md hover:text-primary-900"
            >
              <FaInstagram className="hover:text-orange-400" />
            </Link>
            <Link
              to={"https://www.youtube.com/@Eduprohub"}
              target="_block"
              className="bg-white text-xl text-defaultText p-1 rounded-md hover:text-primary-900"
            >
              <FiYoutube className="hover:text-orange-400" />
            </Link>
            {/* <Link className="bg-white text-xl text-defaultText p-1 rounded-md hover:text-primary-900">
              <FaLinkedinIn className="hover:text-orange-400" />
            </Link> */}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
